export function generateCode(length) {
    let code = '';
    for (let i = 1; i <= length; i++) {
        code += Math.floor(1 + Math.random() * 9).toString();
    }
    return code;
}
//# sourceMappingURL=generateCode.js.map